import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';

import { NewReturnFulfillmentId } from '../../../../orders/order-details/hooks/use-pending-return';
import { useReturnNavigation } from '../../../../orders/order-details/hooks/use-return-navigation';
import { orderDetailsModalOpenedFromShipmentForReturn } from '../../../../store/orders/order-details/orders.details.actions';
import { useCanCreateEnhancedReturn } from '../../../../store/returns/returns.helpers';
import { useTrackWorkflow, WorkflowSteps } from '../../../../tracking/use-workflow-tracking';
import { EventSourceStrings, Workflows } from '../../../../tracking/tracking-constants';

const messages = defineMessages({
  buttonLabel: {
    description: 'shipment details modal create return button label',
    defaultMessage: 'Create Return',
    id: 'cRDA4B',
  },
  disabledButtonLabelTooltip: {
    description: 'shipment details modal create return tooltip message',
    defaultMessage: "A return label cannot be made from the shipment record for an outbound label that doesn't have an order.",
    id: 'KfFnye',
  },
});

export function CreateReturnButton({ disabled = false, fulfillmentPlanId, hasToolTip = false, salesOrderId }) {
  const dispatch = useDispatch();
  const { navigateToReturn } = useReturnNavigation();
  const trackCreateReturn = useTrackWorkflow(Workflows.CREATE_RETURN_FLOW);
  const shouldUseEnhancedReturn = useCanCreateEnhancedReturn(salesOrderId);

  const createReturn = useCallback(() => {
    trackCreateReturn(WorkflowSteps.START, {
      enhanced: shouldUseEnhancedReturn,
      fulfillmentPlanId,
      salesOrderId,
      source: EventSourceStrings.SHIPMENT_MODAL_HEADER,
    });
    dispatch(
      orderDetailsModalOpenedFromShipmentForReturn({
        isReturnsFromShipment: true,
        fulfillmentPlanId,
      }),
    );
    navigateToReturn(salesOrderId, NewReturnFulfillmentId, shouldUseEnhancedReturn);
  }, [dispatch, fulfillmentPlanId, navigateToReturn, salesOrderId, shouldUseEnhancedReturn, trackCreateReturn]);

  return (
    <Tooltip position='bottom' shouldHideTooltip={!hasToolTip} text={<FormattedMessage {...messages.disabledButtonLabelTooltip} />}>
      <div>
        <Button disabled={disabled} onClick={createReturn} theme='white'>
          <FormattedMessage {...messages.buttonLabel} />
        </Button>
      </div>
    </Tooltip>
  );
}

CreateReturnButton.propTypes = {
  disabled: PropTypes.bool,
  hasToolTip: PropTypes.bool,
  fulfillmentPlanId: PropTypes.string,
  salesOrderId: PropTypes.string,
};
